import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=501b50b1&scoped=true&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=501b50b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b50b1",
  null
  
)

export default component.exports